export default function ({ store }) {
  const lastSyncedWallet = localStorage.getItem('LAST_SYNCED_WALLET')
  if (lastSyncedWallet && !store.getters.synced) {
    console.info(`Using last connected wallet type ${lastSyncedWallet}`)
    store.dispatch('initWallet', { type: lastSyncedWallet, skipPrompt: true })
  }

  // Potentially sync other store items to localStorage
}
